/* eslint-disable */
export const SCOPE = 'dimensionContainer';
export const TOGGLE_DIAG_CHART = `${SCOPE}/TOGGLE_DIAG_CHART`;
export const PUSH_DRILLDOWN_FILTER = `${SCOPE}/PUSH_DRILLDOWN_FILTER`;
export const PUSH_MULTI_DRILLDOWN_FILTER = `${SCOPE}/PUSH_MULTI_DRILLDOWN_FILTER`;
export const ADD_DIMENSION_TO_DRAWER = `${SCOPE}/ADD_DIMENSION_TO_DRAWER`;
export const TOGGLE_DIMENSION_IN_COMPARE_DRAWER = `${SCOPE}/TOGGLE_DIMENSION_IN_COMPARE_DRAWER`;
export const SELECT_MULTIPLE_DIMENSION_IN_COMPARE_DRAWER = `${SCOPE}/SELECT_MULTIPLE_DIMENSION_IN_COMPARE_DRAWER`;
export const UNSELECT_MULTIPLE_DIMENSION_IN_COMPARE_DRAWER = `${SCOPE}/UNSELECT_MULTIPLE_DIMENSION_IN_COMPARE_DRAWER`;
